import { ITAdminProvider } from "../../context/ITAdminContext";
import { useState } from "react";
import ITASidebar from "./ITASidebar";
import ITATopbar from "./ITATopbar";
import ITADashPg from "./ITADashPg";
import ITAAnalyticsPg from "./ITAAnalyticsPg";
import ITAAssetsPg from "./ITAAssetsPg";
import ITACredsPg from "./ITACredsPg";
import ITAPeoplePg from "./ITAPeoplePg";
import ITAReqsPg from "./ITAReqsPg";
import ITAExitPg from "./ITAExitPg";
import ITALogsPg from "./ITALogsPg";
import ITANotificationsPage from "./ITANotificationpg";
import ITANotesPg from "./ITANotesPg";
import ITAChatPg from "./ITAChatPg";
import ITACalendarPg from "./ITACalendarPg";
import ITAAnnouncePg from "./ITAAnnouncePg";
import '../../assets/styles/itadmin.css';

function ITAPageView({a, onNavigate}){
  switch(a){
    case "dashboard":return <ITADashPg/>;
    case "analytics":return <ITAAnalyticsPg/>;
    case "assets":return <ITAAssetsPg/>;
    case "credentials":return <ITACredsPg/>;
    case "people":return <ITAPeoplePg/>;
    case "requests":return <ITAReqsPg/>;
    case "exit":return <ITAExitPg/>;
    case "logs":return <ITALogsPg/>;
    case "notifications":return <ITANotificationsPage onNavigate={onNavigate}/>;
    case "notes":return <ITANotesPg/>;
    case "chat": return <ITAChatPg />;
    case "calendar": return <ITACalendarPg />;
    case "announce": return <ITAAnnouncePg />;
    default:return <ITADashPg/>;
  }
}

function ITAdminDashboardInner({onLogout}){
  const [a,setA]=useState("dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return(
    <div className={`R ${sidebarOpen ? "sb-open" : "sb-collapsed"}`}>
      <div className="SB-hotzone" onMouseEnter={() => setSidebarOpen(true)} />
      <button
        type="button"
        className="SB-peek"
        onMouseEnter={() => setSidebarOpen(true)}
        aria-label={sidebarOpen ? "Hide menu" : "Show menu"}
      >
        {sidebarOpen ? "‹" : "›"}
      </button>
      <ITASidebar a={a} set={setA} onLogout={onLogout} sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen}/>
      <div className="MW">
        <ITATopbar a={a} set={setA} onLogout={onLogout}/>
        <div className="MC" key={a}><ITAPageView a={a} onNavigate={setA}/></div>
      </div>
    </div>
  );
}
export default function ITAdminDashboard(props) {
  return <ITAdminProvider><ITAdminDashboardInner {...props} /></ITAdminProvider>;
}
